const VALID_CHARS_REGEX = /^[0-9\s()+\-]+$/;

// Strip all formatting characters, normalise country code to leading 0
export function normalizePhoneNumber(phone: string): string {
  // Strip everything except digits and +
  let digits = phone.replace(/[^0-9+]/g, '');

  // Normalize all international prefix variants to local 0-prefix
  if (digits.startsWith('+61') || digits.startsWith('+64')) {
    digits = '0' + digits.slice(3);
  } else if (digits.startsWith('0061') || digits.startsWith('0064')) {
    digits = '0' + digits.slice(4);
  } else if (digits.startsWith('61') || digits.startsWith('64')) {
    digits = '0' + digits.slice(2);
  }

  if (digits.startsWith('00')) {
    digits = digits.slice(1);
  }

  return digits;
}

export function getPhoneNumberCountry(phone?: string): 'Australia' | 'New Zealand' | null {
  if (!phone) {
    return null;
  }
  return getCountryFromNormalized(normalizePhoneNumber(phone));
}

export function isValidPhoneNumber(phone: string): boolean {
  if (!phone || !VALID_CHARS_REGEX.test(phone)) {
    return false;
  }

  return isValidNormalizedPhone(normalizePhoneNumber(phone));
}

function isValidNormalizedPhone(digits: string): boolean {
  return (
    isAustralianMobile(digits) ||
    isAustralianLandline(digits) ||
    isNewZealandMobile(digits) ||
    isNewZealandLandline(digits)
  );
}

function getCountryFromNormalized(digits: string): 'Australia' | 'New Zealand' | null {
  if (isAustralianMobile(digits) || isAustralianLandline(digits)) {
    return 'Australia';
  }
  if (isNewZealandMobile(digits) || isNewZealandLandline(digits)) {
    return 'New Zealand';
  }
  return null;
}

export function isValidMobilePhoneNumber(phone: string): boolean {
  if (!phone) {
    return false;
  }
  if (!VALID_CHARS_REGEX.test(phone)) {
    return false;
  }

  const normalized = normalizePhoneNumber(phone);
  return isAustralianMobile(normalized) || isNewZealandMobile(normalized);
}

function isAustralianMobile(digits: string): boolean {
  return /^04\d{8}$/.test(digits);
}

function isAustralianLandline(digits: string): boolean {
  return /^0[2378]\d{8}$/.test(digits);
}

function isNewZealandMobile(digits: string): boolean {
  return /^02\d{7,9}$/.test(digits);
}

function isNewZealandLandline(digits: string): boolean {
  return /^0[34679]\d{7,9}$/.test(digits) && !isAustralianMobile(digits);
}
